<template>
  <div>
    <b-row>
      <b-col md="9">
        <b-row>
          <b-col md="6">
            <div style="display: inline-block">
              <h4 style="display: inline">Unit:&nbsp;</h4>
              <p style="display: inline">{{ unitInfo.Unit }}</p>
              <b-button size="sm" class="edit-btn" @click="editUnitInfo">
                <i class="fa fa-pencil text-white"></i>
              </b-button>
            </div>
          </b-col>
          <b-col md="4">
            <div style="display: inline-block">
              <h4 style="display: inline">Status:&nbsp;</h4>
              <p style="display: inline">{{ unitInfo.Occupancy }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <div style="display: inline-block">
              <h4 style="display: inline">Unit Spec:&nbsp;</h4>
              <p style="display: inline">{{ unitInfo.description_summary }}</p>
            </div>
          </b-col>
          <b-col md="4">
            <div style="display: inline-block">
              <h4 style="display: inline">Square Footage:&nbsp;</h4>
              <p style="display: inline">{{ unitInfo.squareFoot || 0 }} sqft.</p>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="3">
        <img
          :src="
            unitInfo.product_summary.images.alternateImages[0].fileUrl
              ? unitInfo.product_summary.images.alternateImages[0].fileUrl
              : '@/assets/images/building.jpg'
          "
          class="image"
        />
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
export default {
  props: {
    unitInfo: {
      type: Object,
      required: true,
      default: () => ({
        unitNumber: "#1",
        status: "Vacant",
        unitSpec: "0 Bed - 1 Bath",
        squareFootage: "20000",
        imageSrc: "@/assets/images/building.jpg",
      }),
    },
  },
  methods: {
    editUnitInfo() {
      this.$router.push({
        name: "Update Unit Info",
        params: { id: this.unitInfo._id, data: this.unitInfo},
      });
    },
  },
};
</script>

<style>
.image {
  width: 255px;
  height: 130px;
  margin-left: -12px;
  margin-top: -12px;
}
.edit-btn {
  border-radius: 50px;
  height: 24px;
  width: 24px;
  line-height: 20px;
  padding: 0;
  margin-left: 5px;
}
</style>
